import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { intervals, update_location_data, aIntervals } from './interfaces/interfaces';
import { DeviceUUID } from 'device-uuid';
import { debounceTime, from, Subscription } from 'rxjs';
import { calculateTotalWorkedSeconds, formatTime, getCurrentTimeFormatted, pauseTimer, startTimer } from './function/function-interval';
import { MarkingService } from 'src/app/shared/components/marking/service/marking.service';
import { IndexedDBDexieService } from 'src/app/core/indexedDB/service/indexed-db-dexie.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AttendanceLocationService } from 'src/app/modules/core/attendance/service/attendance-location.service';
import { IntervalService } from './service/interval-service.service';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { RequestMarkAttendance, Schedule } from 'src/app/shared/components/marking/interfaces/mark.interface';
import * as moment from 'moment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { SmartAlertService } from 'src/app/shared/components/smart-alert/smart-alert.service';
import { MARK_METHOD } from 'src/app/core/auth/functions/enums';
import { MODAL_SIZING_ONE_COLUMN } from 'src/app/shared/components/marking/helpers/enums';
import { MatMenuModule } from '@angular/material/menu';
import { SmartAlertResult } from 'src/app/shared/components/smart-alert/interfaces/custom-dialog.interface';
import { AttendanceRefreshService } from 'src/app/modules/core/attendance/service/attendance-refresh.service';
import { TrademarkRegularizationComponent } from '../trademark-regularization/trademark-regularization.component';
import { ToasService } from 'src/app/shared/components/toast-alert/service/toas-service.service';
import { AccessService } from 'src/app/core/services/access.service';
@Component({
  selector: 'mg-interval-marks',
  standalone: true,
  imports: [IconComponent, CommonModule, MatTooltipModule, MatMenuModule],
  templateUrl: './interval-marks.component.html',
  styleUrl: './interval-marks.component.scss'
})
export class IntervalMarksComponent implements OnInit, OnDestroy {
  @Input() marks_created: any;
  @Input() myHours: any;
  @Input() extemp_data: any;
  @Input() isDesktop: boolean | null;
  @Output() UpdateAttendance = new EventEmitter<boolean>();
  data: aIntervals[];
  now = moment();
  isRunning = false;
  isLoadingExtemp = false;
  isLoading = false;
  hasStartedOnce = false;
  elapsedSeconds = 0;
  formattedTime = '00:00:00';
  currentDate: string = '--:--';
  timerSubscription: Subscription | null = null;
  nid_colab: any;
  dataHintDisabledMovil: { isMovil: boolean; entryMark: boolean; };
  marksRefresh: boolean;
  refreshAll: boolean;
  errorData = {
    status: false,
    message: ''
  };
  marks: any
  //EXTEMPORANEO
  redButtonExist: boolean;
  //DEVICE
  trueProps: string[];
  uuid = new DeviceUUID().get();
  deviceData = new DeviceUUID().parse();
  geolocation: any;
  //SCHEDULE
  schedule: Schedule | null;
  misHoras: any[] = [];
  loading: boolean;
  intervals: any[] = [];
  bUsePermissionLocation: boolean = false
  isIntervalDisabled = false;
  marksIntervalDetail: any;
  viewDetailActive = false;
  HasaFinallMark: boolean = false;
  bOpenLastMark: boolean = false;
  configClosing: any
  configMarksTime: any

  constructor(
    private readonly _intervalService: IntervalService,
    private readonly _markingService: MarkingService,
    private readonly _indexedDB: IndexedDBDexieService,
    private readonly router: Router,
    private readonly _locationAtten: AttendanceLocationService,
    private readonly dialog: MatDialog,
    private readonly _smartAlertService: SmartAlertService,
    private readonly _getLocation: AttendanceLocationService,
    private readonly _attendanceRefreshService: AttendanceRefreshService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _toastService: ToasService,
    public readonly _accessService: AccessService
  ) {
    this.nid_colab = localDB.getItem('idColaborador');
    this.dataHintDisabledMovil = {
      isMovil: Number.parseInt(localDB.getItem('resolucionEsMovil') || '0') == 0 ? false : true,
      entryMark: false
    };
  }

  ngOnInit(): void {
    this.loadConfig()
    this.evaluateDisableInterval()
    this.initMarks();
    this.validateDeviceMark();
    this.restoreIntervalStatus()
    this.trueProps = Object.entries(this.deviceData).filter(([key, value]) => value === true).map(([key, value]) => key);
    let isRestoring = false;
    this.loadConfig()
    this._intervalService.eventMarks$
      .pipe(debounceTime(300))
      .subscribe(isReloadMarks => {
        if (isReloadMarks && !isRestoring) {
          isRestoring = true;
          this.initMarks();
          const extempData = JSON.parse(localDB.getItem('extemp_data') || '{}');
          const hasExtemp = extempData?.isSuccess === true;
          if (!hasExtemp) {
            this.restoreIntervalStatus(true);
          }
          isRestoring = false;
        }
      });
  }

  reloadData() {
    this._indexedDB.refreshDataByAnyKey('endpoints', 'name', ['api/marcacion/marksDayBefore?dDate_Mark=']).subscribe(() => {
      this.marksRefresh = true
      this.refreshAll = !this.refreshAll
    })
  }

  loadConfig() {
    this._activatedRoute.data.subscribe((data) => {
      this.configClosing = data['preferences'][1]['CLOSING_DATE_MARKS']
      this.configMarksTime = data['preferences'][1]['MARKS_TIME']
    })
  }

  initMarks() {
    this.misHoras = JSON.parse(localDB.getItem('V-HORARIO') || '[]');
    this.marks = JSON.parse(localDB.getItem('marks-user'));
    this.intervals = JSON.parse(localDB.getItem('Intervals'));
    this.getButtonRedStatus()
  }

  validateDeviceMark() {
    let currentMethod: number;
    if (this.deviceData.isAndroid || this.deviceData.isiPhone) {
      currentMethod = MARK_METHOD.WEB_MOBILE;
    } else if (this.deviceData.isDesktop || this.deviceData.isWindows || this.deviceData.isMac) {
      currentMethod = MARK_METHOD.WEB_DESKTOP;
    } else {
      currentMethod = MARK_METHOD.EQUIPOS;
    }

    const intervals = this.misHoras ?? [];
    const marksList = this.marks?.data?.aIntervals ?? [];

    if (intervals.length === 0) {
      this.isIntervalDisabled = false;
      return;
    }

    const nextIndex = marksList.length;

    if (nextIndex >= intervals.length) {
      this.isIntervalDisabled = false;
      return;
    }

    const intervalToValidate = intervals[nextIndex];

    const allowed = intervalToValidate?.aMarking_alowed;
    if (!Array.isArray(allowed) || allowed.length === 0) {
      this.isIntervalDisabled = true;
      return;
    }

    this.isIntervalDisabled = !allowed.includes(currentMethod);

  }


  restoreIntervalStatus(restore?: boolean) {
    pauseTimer(this.timerSubscription);
    const now = new Date();
    const arr: aIntervals[] = this.marks.data?.aIntervals ?? [];
    if (restore === true && arr.length === 0) {
      this.elapsedSeconds = 0;
      this.formattedTime = formatTime(this.elapsedSeconds);
      this.isRunning = false;
      this.hasStartedOnce = false;
      pauseTimer(this.timerSubscription);
      return;
    }

    if (arr.length > 0) {
      const sortedArr = [...arr].sort((a, b) => new Date(a.dDate).getTime() - new Date(b.dDate).getTime());
      const firstarr = sortedArr[0];
      const finallarr = sortedArr[sortedArr.length - 1];
      const totalSeconds = calculateTotalWorkedSeconds(sortedArr);
      this.elapsedSeconds = totalSeconds;

      if (finallarr?.nType_Mark === 1) {
        this.formattedTime = formatTime(this.elapsedSeconds);
        this.start(false);
        this.currentDate = this.getClosestMarkTime(arr);

        this.hasStartedOnce = true;
      }

      if (finallarr?.nType_Mark === 2) {
        this.formattedTime = formatTime(this.elapsedSeconds);
        this.pause(false);
        this.currentDate = this.getClosestMarkTime(arr);
        this.hasStartedOnce = true;
      }
    }
  }

  getClosestMarkTime(arr: aIntervals[]): string {
    if (!arr || arr.length === 0) return '--:--';
    const now = moment();
    const closest = [...arr].sort((a, b) => {
      const diffA = Math.abs(now.diff(moment(a.dDate)));
      const diffB = Math.abs(now.diff(moment(b.dDate)));
      return diffA - diffB;
    })[0];

    return moment(closest.dDate).format('HH:mm');
  }

  getButtonRedStatus() {
    let extemporainous_data = JSON.parse(localDB.getItem('extemp_data'));
    this.extemp_data.data = extemporainous_data.data;
    this.redButtonExist = extemporainous_data.isSuccess == true ? true : false;
  }

  refreshButtonsList(refresh: boolean) {
    this.loading = true;
  }
  evaluateDisableInterval() {
    from(this._getLocation.getLocation()).subscribe({
      next: (location: any) => {
        if (location.isSuccess == false) {
          this._smartAlertService.init({
            type: 'warning',
            message: location.sMessage,
            showCancelButton: false,
            showConfirmButton: true
          });
        }
        this.geolocation = location
        this._intervalService.MyGeolocation(location)
        const horario = JSON.parse(localDB.getItem('V-HORARIO') || '[]');
        const result = horario.length > 0 && horario[0].nDay === 0;
        result || this.geolocation.isSuccess == false ? this.isIntervalDisabled = true : false;
      }
    });
  }


  errorByLocation(bUsePermision: boolean = true) {
    this._locationAtten.differenctBSedeAndLocation(bUsePermision).subscribe(loc => {
      this.errorData.message = loc.sMessage
      this.errorData.status = !loc.isSuccess
      this.bUsePermissionLocation = true
    })
  }

  get currentInterval() {
    let LastRecommendMark = this.misHoras.at(-1);
    this.HasaFinallMark = this.marks.data.aIntervals.some((interval: aIntervals) => interval.nType_Mark === 2 && moment(interval.dDate).isSameOrAfter(moment(LastRecommendMark?.dtime)));
    if (!this.hasStartedOnce) return intervals[1];
    if (this.HasaFinallMark == false && this.misHoras.length != 0) {
      if (this.shouldFinalize == true) return intervals[4];
    }
    return this.isRunning ? intervals[2] : intervals[3];
  }

  get shouldFinalize(): boolean {
    let LastRecommendMark = this.misHoras.at(-1);
    let lastMark = this.marks.data.aIntervals.at(-1);
    this.bOpenLastMark = lastMark?.nType_Mark == 1 ? true : false
    let result = this.bOpenLastMark && this.now.isSameOrAfter(LastRecommendMark.dtime) ? true : false
    return result
  }

  toggleTimer() {
    this.currentDate = getCurrentTimeFormatted(this.marks, true);
    this.isRunning
      ? this.pause(true)
      : this.start(true);
  }

  async start(savemark: boolean) {
    this.initMarks();
    if (savemark == true) {
      const marks = this.marks.data.aIntervals.length ?? 1;
      const dHourISO = this.misHoras?.[marks]?.dtime;
      const nTolerancia = this.misHoras?.[marks]?.nRango_Minimo;
      const formattedDHour = moment(dHourISO);
      const toleratedMoment = moment(formattedDHour).add(nTolerancia, 'minutes')
      if (this.now.isAfter(toleratedMoment)) {
        this.validateMarks(this.misHoras);
      } else {
        this.savemark(null, true, this.marks);
      }
    }
    this.timerSubscription = startTimer(this.elapsedSeconds, (seconds) => {
      this.elapsedSeconds = seconds;
      this.formattedTime = formatTime(this.elapsedSeconds);
    });
    this.isRunning = true;
    this.hasStartedOnce = true;
  }

  pause(savemark: boolean) {
    this.initMarks();
    if (savemark == true) {
      const marks = this.marks.data.aIntervals.length ?? 1;
      const dHourISO = this.misHoras?.[marks]?.dtime;
      const nTolerancia = this.misHoras?.[marks]?.nRango_Minimo;
      const formattedDHour = moment(dHourISO);
      const toleratedMoment = moment(formattedDHour).add(nTolerancia, 'minutes')
      if (this.now.isAfter(toleratedMoment)) {
        this.validateMarks(this.misHoras)
      } else {
        this.savemark(null, true, this.marks);
      }
    }
    pauseTimer(this.timerSubscription);
    this.isRunning = false;
  }


  async validateMarks(myHours: any): Promise<boolean> {
    const now = moment();
    const marks = this.marks.data.aIntervals.length ?? 1;
    const dHourISO = myHours?.[marks]?.dtime;
    const nTolerancia = myHours?.[marks]?.nTolerancia;
    const formattedDHour = moment(dHourISO);
    const toleratedMoment = moment(formattedDHour).add(nTolerancia, 'minutes');
    if (now.isBefore(formattedDHour.clone().subtract(1, 'hour')) || now.isAfter(toleratedMoment)) {
      const { confirmed } = await this.justificationWarning(
        "Marcación fuera de rango",
        "Recuerda marcar a la hora establecida"
      );
      return confirmed;
    } else {
      return true;
    }
  }

  private justificationWarning(title: string, text: string): Promise<{ confirmed: boolean, inputValue: string }> {
    return new Promise((resolve) => {
      this._smartAlertService.init({
        type: 'quest',
        title,
        message: text,
        showCancelButton: true,
        showConfirmButton: true,
        showInput: true,
        inputRequired: true,
        inputPlaceholder: 'Ingrese motivo de tardanza'
      }).subscribe((result: { confirmStatus: boolean, denyStatus: boolean, inputValue: string }) => {
        this._smartAlertService.close();
        if (result?.confirmStatus) {
          const confirmed = true
          resolve({ confirmed: true, inputValue: result.inputValue });
          this.savemark(result.inputValue, confirmed, this.marks);
        } else {
          this.isIntervalDisabled = false;
          this.currentDate = '--:--'
          this.restoreIntervalStatus(true);
          resolve({ confirmed: false, inputValue: '' });
        }
      });
    });
  }

  async savemark(justificacion?: string | null, accept?: boolean, intervaldata?: any | null) {
    this.activateDisableInterval();
    let data: RequestMarkAttendance | {} = {};
    try {
      data = await this.generateRequestToCreateMark(justificacion, accept, intervaldata);
      this.setIntervalsMark(data)
      this._intervalService.ReloadDashboard(true)
    } catch (err) {
      console.error(err, 'error al crear marca');
    } finally {
      this._markingService.createMarkNew(data).subscribe({
        next: (response) => {
          if (response.isSuccess) {
            this.UpdateAttendance.emit(this.HasaFinallMark == false ? true : false);
            this.getDeviceLocation(response.data.nId_Mark);
            this._attendanceRefreshService.triggerRefresh();
          } else {
            this._smartAlertService.init(
              {
                type: 'warning',
                message: response.message,
                showCancelButton: false,
                showConfirmButton: true
              }).subscribe((result: SmartAlertResult) => {
                result.confirmStatus ? window.location.reload() : window.location.reload()
              });
          }
        }
      })
    }
  }

  async generateRequestToCreateMark(justificacion?: string | null, acepto?: boolean, intervaldata?: any): Promise<RequestMarkAttendance> {
    let a = navigator.userAgent.replace(' (', '-').replace(') ', '-');
    let b = a.replace(' (', '-').replace(') ', '-').split('-');
    let deviceData = {
      sBrowser: b[b.length - 1],
      sUid: this.uuid,
      nWidth: this.deviceData.resolution[0],
      nHeight: this.deviceData.resolution[1],
      sOS: b[1],
      bEmulated: this.imEmulate(window.innerWidth, this.deviceData.resolution[0], this.trueProps),
      nMethod: this.deviceData.resolution[0] > 792 ? MARK_METHOD.WEB_DESKTOP : MARK_METHOD.WEB_MOBILE,
    }

    let requestCreateMark = {
      sJustificacion: justificacion != undefined ? justificacion : null,
      bAcepta_Marca_Fuera_De_Tiempo: acepto != undefined ? acepto : false,
      nMetodo_Marcaje: "web",
      sMessage_Error: null,
      dFecha_Jornada: moment().format("YYYY-MM-DD"),
      nInterval: null,
      nTypeInterval: 1,
      dTiempo_Marca: moment.utc().add(-5, 'hours').toDate(),
      deviceInfo: deviceData
    };
    const intervals = intervaldata?.data?.aIntervals ?? [];
    const index = intervals.length;
    requestCreateMark["nTypeInterval"] = (index % 2 === 0) ? 1 : 2;

    return requestCreateMark;
  }

  async getDeviceLocation(mark_id: number) {
    let neLocation = this.geolocation;
    const data: update_location_data = {
      nId_Mark: mark_id,
      oLocatio_mark: {
        nlat: neLocation.latitude,
        nlng: neLocation.longitude,
      }
    };
    this._toastService.updateToastData({
      type: 'info',
      message: 'Actualizando geolocalización ...',
      timer: 3,
      redirectionButtom: false,
      bMostrar: true,
      position: 'top-r',
    });
    const minDisplayTime = 2000; 
    const startTime = Date.now();
    this._intervalService.UpdateLocation(data).subscribe({
      next: (res) => {
        this.initMarks();
        const elapsedTime = Date.now() - startTime;
        const delay = Math.max(0, minDisplayTime - elapsedTime);
        setTimeout(() => {
          if (!res.data.issuccess) {
            this._toastService.updateToastData({
              type: 'danger',
              title: 'Error',
              message: res.data.smessage,
              timer: 3,
              redirectionButtom: false,
              bMostrar: true,
              position: 'top-r',
            });
            this._smartAlertService.init(
              {
                type: 'warning',
                message: res.data.smessage,
                showCancelButton: false,
                showConfirmButton: true
              }).subscribe((result: SmartAlertResult) => {
                globalThis.location.reload();
              });
          } else {
            this._toastService.updateToastData({ bMostrar: false });
          }
        }, delay);
      },
      error: () => {
        const elapsedTime = Date.now() - startTime;
        const delay = Math.max(0, minDisplayTime - elapsedTime);
        setTimeout(() => {
          this._toastService.updateToastData({ bMostrar: false });
        }, delay);
      }
    });
  }

  imEmulate(currentWidth: number, realWidth: number, trueProps: string[]) {
    if (currentWidth > realWidth && trueProps.includes('isDesktop') && realWidth < 792) {
      return 1
    } else {
      return 0
    }
  }


  ngOnDestroy() {
    this.pause(false);
  }

  ExtemporaniousMark(): string {
    return this.redButtonExist ? 'error' : 'schedule';
  }

  activateDisableInterval() {
    this.isIntervalDisabled = true;
    setTimeout(() => {
      this.isIntervalDisabled = false;
    }, 60000);
  }

  onLastMarkClick() {
    if (!this._accessService.validarPermisoSlug('MARKS-CRUD-MODAL')) return;
    this.redButtonExist ? this.OpenExtempModal() : this.viewDetails();
  }

  viewDetails() {
    this.dialog.open(TrademarkRegularizationComponent, {
      width: MODAL_SIZING_ONE_COLUMN.WIDHT,
      maxWidth: MODAL_SIZING_ONE_COLUMN.MAX_WIDTH,
      height: MODAL_SIZING_ONE_COLUMN.HEIGHT,
      data: {
        ...this.intervals,
        CLOSING_DATE: this.configClosing,
        MARKS_TIME: this.configMarksTime
      },
      disableClose: true,

    });
  }

  OpenExtempModal() {
    let date = new Date(this.extemp_data.data.dFecha_Marca);
    this.isLoadingExtemp = true;
    this._intervalService.getMarksUser(this.nid_colab, moment(date).format("YYYY-MM-DD"), false, true).subscribe({
      next: (resp) => {
        this.isLoadingExtemp = false;
        if (resp) {
          const dialog = this.dialog.open(TrademarkRegularizationComponent, {
            width: MODAL_SIZING_ONE_COLUMN.WIDHT,
            maxWidth: MODAL_SIZING_ONE_COLUMN.MAX_WIDTH,
            height: MODAL_SIZING_ONE_COLUMN.HEIGHT,
            data: {
              nId: this.nid_colab,
              dFechaMarcacion: date,
              extemp_data: resp,
              calendarmode: 'read',
              CLOSING_DATE: this.configClosing,
              MARKS_TIME: this.configMarksTime
            },
            disableClose: true,
          });

          dialog.afterClosed().subscribe(result => {
            if (result) {
              this._markingService.getRedButton().subscribe({
                next: () => this.getButtonRedStatus()
              });
            }
          });
        }
      },
      error: (err) => {
        this.isLoadingExtemp = false;
        console.error("Error obteniendo marcas:", err);
      }
    });
  }

  setIntervalsMark(intervaldata: RequestMarkAttendance | {} = {}) {
    let ua = navigator.userAgent.toLowerCase();
    let isMobile = /mobi|android|iphone|ipod/.test(ua);
    let isTablet = /ipad|tablet/.test(ua);
    let id: number = 1
    const IntervalsExist = JSON.parse(localDB.getItem('Intervals')) || { aIntervals: [], dFecha_Jornada: '' };
    const last = IntervalsExist.aIntervals.at(-1);
    if (IntervalsExist.aIntervals.length != 0) id = last.nType_Mark === 2 ? last.nInterval + 1 : last.nInterval
    const data = intervaldata as RequestMarkAttendance;
    let newmark: aIntervals = {
      dDate: moment.utc(data.dTiempo_Marca).format('YYYY-MM-DD HH:mm:ss'),
      dFecha_Jornada: data.dFecha_Jornada,
      lat: 0,
      lon: 0,
      nInterval: id,
      nType_Mark: data.nTypeInterval,
      nMetodo_Marcaje: data.deviceInfo.nMethod,
      sMetodo_Marcaje: data.nMetodo_Marcaje,
      sIcono_Marcaje: isMobile ? 'mobile' : isTablet ? 'tablet_mac' : 'desktop_windows',
      bIs_Extemporanea: 0,
    };

    IntervalsExist.aIntervals.push(newmark);

    localDB.setItem('Intervals', JSON.stringify(IntervalsExist));

    this.intervals = JSON.parse(localDB.getItem('Intervals'));
  }
}